import { timestampsMap } from "./timestamps";

export const surgicalTeamsMap: GenericObject = {
	nome: "name",
	...timestampsMap,
};
